import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-24 md:py-32 text-center">
      <p className="font-heading font-extrabold text-7xl md:text-9xl text-background-300 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading font-bold text-2xl text-foreground-950">
        抱歉，这个页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在或已被移除。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-film-line"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}